import { render, staticRenderFns } from "./IcoChat.vue?vue&type=template&id=01c89930"
import script from "./IcoChat.vue?vue&type=script&lang=js"
export * from "./IcoChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports